import React from 'react';

// The pink icon in a soft pink square before a section title (as on the earlier report page); decorative only
export const SectionIcon = ({ icon: Icon }) => (
    <span className="sec-ic" aria-hidden="true">
        <Icon />
    </span>
);
